import ReactModal from 'react-modal';
import type { JSX } from 'react';
/**
 * 未設定項目確認モーダル
 */
export default function WsModalContentConfirm(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  title: string;
  onSubmit: () => void;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 定数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ステート定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じます。
   */
  const onClose = () => {
    props.setOpen(false);
  };

  /**
   * 登録するボタンがクリックされた時の処理
   */
  const onSubmit = () => {
    props.onSubmit();
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: 'rgba(30, 30, 30,0.5)',
          },
          content: {
            maxWidth: '500px',
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div
          id="settings-modal"
          className="modal2 modal-content rounded-4 "
          style={{ maxWidth: 'none' }}
        >
          <div className="modal-body">
            <h3 className="modal-title text-center mt-5" id="settings-modal-label">
              {props.title}
            </h3>
            <p className="lead text-center mb-4">
              登録画面を開きますか？
              <br />
              （編集中のコンテンツの状態は保存されます）
            </p>

            <div className="modal-footer border-top-0 justify-content-center mt-4">
              <button onClick={onClose} type="button" className="btn btn-secondary">
                キャンセル
              </button>
              <button onClick={onSubmit} type="button" className="btn btn-submit">
                登録する
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
